<template>
  <v-fade-transition mode="out-in">
    <router-view />
  </v-fade-transition>
</template>

<script>
  // Styles
  import '@/styles/overrides.sass'

  export default {
    name: 'Arrandi',
    metaInfo: {
      title: 'Arrandi',
      titleTemplate: '%s | Trouvez vos financements !',
      htmlAttrs: { lang: 'fr' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },
    computed: {
      currentUser () {
        return this.$store.state.auth.user
      },
    },
    methods: {
      logOut () {
        this.$store.dispatch('auth/logout')
        this.$router.push('/login')
        Vue.nextTick(callback)
      },
    },
  }
</script>
